import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PbxContext from '../../context/PbxContext';
import {
  accessLocalStorage,
  getDataDashboard,
  exportReportGenerate,
  chartEndpointsReceiveds,
  chartHoursReceiveds,
  chartSectorsReceiveds,
  chartDaysReceiveds,
  chartResumeReceiveds,
  chartEndpointsSendeds,
  chartHoursSendeds,
  chartDaysSendeds,
  chartResumeSendeds,
  chartResumeInternals,
  exportReportGenerateLogs,
  logsReport,
  exportSelectAllEndpoints,
  chartSectorsGlobal
} from '../../services';

import { buildEndpointsIndex } from '../../utils/labelFormatters';

// import '../../libs/bulma.min.css';
import './styles.css';

import Loading from '../../components/Loading/LoadingModule';
import ChartsRecivedCalls from '../../components/Dashboard/ChartsRecivedCalls';
import ChartsSendedsCalls from '../../components/Dashboard/ChartsSendCalls';
import ReportList from '../../components/Dashboard/ReportList';
import Pagination from '../../components/Dashboard/Pagination';
import ChartCallsStatusGlobal from '../../components/Dashboard/ChartCallsStatusGlobal';
import ChartBySector from '../../components/Dashboard/ChartBySector';
import ChartCallsReceivedsByTime from '../../components/Dashboard/ChartCallsReceivedsByTime';
import ChartCallsSendedsyTime from '../../components/Dashboard/ChartCallsSendedsyTime';
import ChartCallsReceivedsByDay from '../../components/Dashboard/ChartCallsReceivedsByDay';
import ChartCallsSendedsByDay from '../../components/Dashboard/ChartCallsSendedsByDay';
import TableReceivedCalls from '../../components/Dashboard/TableReceivedCalls';
import TableSentCalls from '../../components/Dashboard/TableSentCalls';
import FilterReportsCalls from '../../components/Dashboard/FilterReportsCalls';
import SaveButton from '../../components/Buttons/SaveButton';
import DownloadButton from '../../components/Buttons/DownloadButton';

const DASHBOARD_DATA_DEFAULT = {
  endpointsReceiveds: {},
  endpointsSendeds: {},
  queues: {},
  globalQueues: {},
  internalAndExternals: {},
  volumeCallsInternalsAndExternals: {},
  receivedsHours: {},
  sendedsHours: {},
  receivedsDays: {},
  sendedsDays: {},
  receivedResume: {},
  sendedsResume: {},
  logs: [],
};

function Reports() {
  const getItensStateGlobal = useContext(PbxContext);
  const { storageDataReport, setStorageDataReport, verifySort, dataForRequestCalls, setDataForRequestCalls } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);

  const [callsReceived, setCallsReceived] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [callsPerPage] = useState(50);
  const [sortElements, setSortElements] = useState({ key: '', direction: 'direction'});
  const [readingDb, setReadingDb] = useState(false);
  const [classButtonGenerateStats, setClassButtonGenerateStats] = useState('');
  const [classButtonGenerateLogs, setClassButtonGenerateLogs] = useState('is-hidden');
  const [classButtonDownloadStats, setClassButtonDownloadStats] = useState('is-hidden');
  const [classButtonDownloadLogs, setClassButtonDownloadLogs] = useState('is-hidden');

  const history = useHistory();
  
  const today = new Date();
  const todayFull = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

  const getAllEndpointsConfig = async (data) => {
    try {
      const {type, filter} = data;
      const endpointsList = await exportSelectAllEndpoints();

      if (endpointsList === undefined) {
        console.warn('[DASHBOARD] endpointsList é undefined');
        return {};
      }

      const elements = buildEndpointsIndex(endpointsList);

      const recEndpointsResultNew = type === 'receiveds' ? await chartEndpointsReceiveds(filter) : await chartEndpointsSendeds(filter);

      if (recEndpointsResultNew && Object.entries(recEndpointsResultNew).length > 0) {
        Object.keys(recEndpointsResultNew).forEach((element) => {
          if (elements[element]) {
            recEndpointsResultNew[element].name = elements[element].display;
          }
        })
      }

      return recEndpointsResultNew || {};
    } catch (error) {
      console.error('[DASHBOARD] Erro em getAllEndpointsConfig:', error);
      return {};
    }
  };

  const fetchDataDashboardIntit = async (filter) => {
    try {
      const data = filter;

      const recEndpointsResult = await getAllEndpointsConfig({type: 'receiveds', filter});
      const recHoursResult = await chartHoursReceiveds(filter);
      const recSectorsResult = await chartSectorsReceiveds(filter);
      const recDaysResult = await chartDaysReceiveds(filter);
      const recResumeResult = await chartResumeReceiveds(filter);
      const recSendedsEndpointsResult = await getAllEndpointsConfig({type: 'sendeds', filter});
      const recSendedsHoursResult = await chartHoursSendeds(filter);
      const recSendedsDaysResult = await chartDaysSendeds(filter);
      const recSendedsResumeResult = await chartResumeSendeds(filter);
      const recInternalsResumeResult = await chartResumeInternals(filter);
      const sectosGlobals = await chartSectorsGlobal(filter);
  
      const result = {
        endpointsReceiveds: recEndpointsResult || {},
        endpointsSendeds: recSendedsEndpointsResult || {},
        queues: recSectorsResult || {},
        globalQueues: sectosGlobals || {},
        internalAndExternals: {},
        receivedsHours: recHoursResult || {},
        sendedsHours: recSendedsHoursResult || {},
        receivedsDays: recDaysResult || {},
        sendedsDays: recSendedsDaysResult || {},
        receivedResume: recResumeResult || {},
        sendedsResume: recSendedsResumeResult || {},
        logs: []
      }
      
      return result;
    } catch (error) {
      console.error('[DASHBOARD] Erro em fetchDataDashboardIntit:', error);
      setLoading(false);
      return null;
    }
  };

  const getDataReportDb = useCallback(async (data) => {
    const req = {
      initDate: todayFull,
      endDate: todayFull,
      initHour: `00:00:00`,
      endHour: `23:59:59`,
      sector: '',
      getEndpoint: '',
      telNumber: '',
      getProtocol: '',
      getStatus: '',
      getType: '',
      getLogs: false,
    };
    const filterItems = !data ? req : data;
    const localFetchDataReport = await fetchDataDashboardIntit(filterItems);
    window.localStorage.setItem('filter_data', JSON.stringify(filterItems));
    setDataForRequestCalls(filterItems);

    return localFetchDataReport; 
  }, [setDataForRequestCalls]);

  const getStatsReport = () => setTimeout(() => window.location.replace(`//${url}/api/report/download-stats`), 1000);
  const getLogsReport = () => setTimeout(() => window.location.replace(`//${url}/api/report/download-logs`), 1000);

  const validateUserLogged = useCallback(async () => {
    try {
      const dataUser = await accessLocalStorage.getUserLocalStorage();
      if (!dataUser) {
        setLoading(false);
        return history.push('/');
      }

      const localFetchDataReport = await getDataReportDb();

      if (!localFetchDataReport) {
        setStorageDataReport(DASHBOARD_DATA_DEFAULT);
        setLoading(false);
        return;
      }

      const mergedReport = { ...DASHBOARD_DATA_DEFAULT, ...localFetchDataReport };
      setStorageDataReport(mergedReport);
      setLoading(false);
    } catch (error) {
      console.error('[DASHBOARD] Erro em validateUserLogged:', error);
      setStorageDataReport(DASHBOARD_DATA_DEFAULT);
      setLoading(false);
    }
  }, [getDataReportDb, history, setStorageDataReport]);
  
  const sendDataExportReportGeneration = async () => {
    const sendDataReport = await exportReportGenerate(storageDataReport);
    setClassButtonGenerateStats('is-hidden');
    setClassButtonDownloadStats('');
    return;
  };
  
  const sendDataExportReportGenerationLogs = async () => {
    await exportReportGenerateLogs(dataForRequestCalls);
    setClassButtonGenerateLogs('is-hidden');
    setClassButtonDownloadLogs('');
    return;
  };

  const getReportRowsFiltred = async (chart, item, status) => {
    const dataStorage = window.localStorage.getItem('filter_data');
    const data = JSON.parse(dataStorage);
    
    const { dateStart } = data;

    data['getLogs'] = true;

    if (chart === 'endpoints-receiveds' || chart === 'endpoints-sendeds') {
      data['getEndpoint'] = item;
      data['getType'] = chart === 'endpoints-receiveds' ? 'recebida' : 'realizada';
      data['getStatus'] = status;
    }
    if (chart === 'queues') {
      data['sector'] = item;
      data['getStatus'] = status;
    }
    if (chart === 'queues-global') {
      const dataUser = await accessLocalStorage.getUserLocalStorage();
      let queues;
      if (dataUser) {
        const { user: { queuesviewer } } = dataUser;
        queues = queuesviewer !== 'all' ? queuesviewer.split(',') : queuesviewer;
      }
      data['sector'] = queues;
      data['getStatus'] = status;
    }
    if (chart === 'receiveds-hours' || chart === 'sendeds-hours') {
      const hour = item.length === 1 ? `0${item}` : item;
      // data['dateStop'] = dateStart;
      data['initHour'] = `${hour}:00:01`;
      data['endHour'] = `${hour}:59:59`;
      data['getType'] = chart === 'receiveds-hours' ? 'recebida' : 'realizada';
      data['getStatus'] = status;
    }
    if (chart === 'receiveds-days' || chart === 'sendeds-days') {
      const fomatedDay = dateStart.split('-');
      const dateDay = `${fomatedDay[0]}-${fomatedDay[1]}-${item.padStart(2, '0')}`;
      data['dateStart'] = `${dateDay}`;
      data['dateStop'] = `${dateDay}`;
      data['getType'] = chart === 'receiveds-days' ? 'recebida' : 'realizada';
      data['getStatus'] = status;
    }
    if (chart === 'receiveds-table' || chart === 'sendeds-table') {
      data['getType'] = chart === 'receiveds-table' ? 'recebida' : 'realizada';
      if (status) data['getStatus'] = status;
    };

    const rows = await logsReport(data);

    if(rows.length > 0) {
      setCallsReceived(rows);
      
      setClassButtonGenerateLogs('');
      setDataForRequestCalls(data);
      return;
    };
    return;
  };

  const indexOfLastCall = currentPage * callsPerPage;
  const indexofFirstCall = indexOfLastCall - callsPerPage;
  const currentCalls = callsReceived.length > 0 ? callsReceived.slice(indexofFirstCall, indexOfLastCall) : [];
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const sendFilterDashboard = async (data) => {
    try {
      const { sector, getEndpoint, telNumber, getProtocol, getType, getLogs } = data;

      const sanitizedEndpoint = ((getEndpoint || '').toString().match(/\d+/) || [''])[0];

      data['getLogs'] = getType === 'interna' || telNumber !== '' || getProtocol !== '' || sanitizedEndpoint !== '' ? true : getLogs;
      data['sector'] = sector.length > 0 ? sector : '';
      data['getEndpoint'] = sanitizedEndpoint;
      data['telNumber'] = telNumber.length > 0 ? telNumber : '';
      data['getProtocol'] = getProtocol.length > 0 ? getProtocol : '';

      setReadingDb(true);
      const localFetchDataReport = await getDataReportDb(data);
      
      if (!localFetchDataReport) {
        setStorageDataReport(DASHBOARD_DATA_DEFAULT);
        setCallsReceived([]);
        setReadingDb(false);
        return;
      }

      setStorageDataReport({ ...DASHBOARD_DATA_DEFAULT, ...localFetchDataReport });
      setCallsReceived(localFetchDataReport.logs || []);
      setDataForRequestCalls(data);

      if (getType === 'interna') {
        const rows = await logsReport(data);

        if(rows && rows.length > 0) {
          setCallsReceived(rows);
          setClassButtonGenerateLogs('');
          setDataForRequestCalls(data);
          setReadingDb(false);
          return;
        }
      }

      setReadingDb(false);
    } catch (error) {
      console.error('[DASHBOARD] Erro em sendFilterDashboard:', error);
      setReadingDb(false);
    }
  };

  useMemo(() => {
    let sortableItems = callsReceived;
    if (sortElements !== null) {
      sortableItems.sort((a, b) => {
        if(sortElements.key === 'duracao' && sortElements.direction === 'ascending') return a[sortElements.key] - b[sortElements.key];
        if(sortElements.key === 'duracao' && sortElements.direction === 'descending') return b[sortElements.key] - a[sortElements.key];
        
        if (a[sortElements.key] < b[sortElements.key]) {
          return sortElements.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortElements.key] > b[sortElements.key]) {
          return sortElements.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    setCallsReceived(sortableItems);
    return;
  }, [callsReceived, sortElements]);

  const sortedCalls = (key) => {
    let direction = 'ascending';
    if (sortElements && sortElements.key === key && sortElements.direction === 'ascending') {
      direction = 'descending';
    }
    setSortElements({ key, direction });
    return;
  };

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div className="dashboard-container">
      {loading ? (
        <Loading />
      ) : (
        <div className="dashboard-content">
          <div className="dashboard-header">
            <div className="dashboard-title-wrapper">
              <svg className="dashboard-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
              <div>
                <h1 className="dashboard-title">Dashboard</h1>
                <p className="dashboard-subtitle">Análise completa de chamadas e métricas</p>
              </div>
            </div>
          </div>

          <div className="filter-section">
            <div className="filter-header">
              <svg className="dashboard-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
              </svg>
              <h1 className="filter-title">Filtro de Chamadas</h1>
            </div>
            <FilterReportsCalls sendFilterDashboard={sendFilterDashboard} readingDb={readingDb} />
          </div>

          <div className="dashboard-section">
            <div className="section-card">
              <div className="card-header-custom">
                <h2 className="card-title">📊 Resumo de Chamadas</h2>
              </div>
              <div className="card-content-custom">
                <div className="charts-grid">
                  <ChartsRecivedCalls getRows={getReportRowsFiltred} />
                  <ChartsSendedsCalls getRows={getReportRowsFiltred} />
                </div>
              </div>
            </div>

            <div className="section-card">
              <div className="card-header-custom">
                <h2 className="card-title">⏰ Chamadas por Hora</h2>
              </div>
              <div className="card-content-custom">
                <div className="charts-grid">
                  <ChartCallsReceivedsByTime getRows={getReportRowsFiltred} />
                  <ChartCallsSendedsyTime getRows={getReportRowsFiltred} />
                </div>
              </div>
            </div>

            <div className="section-card">
              <div className="card-header-custom">
                <h2 className="card-title">📈 Análise Geral</h2>
              </div>
              <div className="card-content-custom">
                <div className="charts-grid">
                  <ChartCallsStatusGlobal getRows={getReportRowsFiltred}/>
                  <ChartBySector getRows={getReportRowsFiltred} />
                </div>
              </div>
            </div>

            <div className="section-card">
              <div className="card-header-custom">
                <h2 className="card-title">📅 Chamadas por Dia</h2>
              </div>
              <div className="card-content-custom">
                <div className="charts-grid">
                  <ChartCallsReceivedsByDay getRows={getReportRowsFiltred}/>
                  <ChartCallsSendedsByDay getRows={getReportRowsFiltred}/>
                </div>
              </div>
            </div>

            <div className="section-card">
              <div className="card-header-custom">
                <h2 className="card-title">📋 Tabelas Detalhadas</h2>
              </div>
              <div className="card-content-custom">
                <div className="charts-grid">
                  <TableReceivedCalls getRows={getReportRowsFiltred} />
                  <TableSentCalls getRows={getReportRowsFiltred} />
                </div>
              </div>
            </div>
            
            <div className="export-actions-card">
              <div className="export-action-item">
                <div className="export-info">
                  <svg className="export-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p className="export-label">Exportar dados do Dashboard</p>
                </div>
                <div className="export-buttons">
                  <SaveButton
                    generateFile={sendDataExportReportGeneration}
                    classStatus={classButtonGenerateStats}
                  />
                  <DownloadButton
                    getFileName={getStatsReport}
                    classStatus={classButtonDownloadStats}
                  />
                </div>
              </div>

              <div className="export-action-item">
                <div className="export-info">
                  <svg className="export-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p className="export-label">Exportar Logs de Chamadas</p>
                </div>
                <div className="export-buttons">
                  <SaveButton
                    generateFile={sendDataExportReportGenerationLogs}
                    classStatus={classButtonGenerateLogs}
                  />
                  <DownloadButton
                    getFileName={getLogsReport}
                    classStatus={classButtonDownloadLogs}
                  />
                </div>
              </div>
            </div>
          </div>

          {callsReceived.length > 0 && (
            <div className="calls-detail-section">
              <div className="section-card">
                <div className="card-header-custom">
                  <h2 className="card-title">📞 Detalhamento de Chamadas</h2>
                </div>
                <div className="card-content-custom">
                  <ReportList callsList={currentCalls} sortedCalls={sortedCalls} verifySort={verifySort} />
                  <Pagination callsPerPage={callsPerPage} totalCalls={callsReceived.length} paginate={paginate} currentPage={currentPage} />
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Reports;
